import NotStartedIcon from '@mui/icons-material/NotStarted';
import TaskIcon from '@mui/icons-material/Task';
import { Inspection, KitOrder } from 'api/Responses/OrderResponses';

export const mapStatusToIcon = (status: Inspection['status'] | KitOrder['status']): JSX.Element => {
  switch (status) {
    case 'COMPLETED':
    case 'CONFIRMED':
      return <TaskIcon color="success" />;
    case 'NEW':
    case 'ONGOING':
    case 'UNCONFIRMED':
      return <NotStartedIcon color="info" />;
  }
};
/**
 *
 * @param gsOne: the name the JnJ Japan team give to their set barcode values. This is constructed as: 01<kitId>10<kitSerial> where a Japanese kit serial always starts with "J"
 * @returns a set/kit serial number
 */
export const gsOneToSerial = (gsOne: string): string => {
  // the serial always starts with J, so we find this char
  const jIndex = gsOne.indexOf('J');

  if (!gsOne) {
    console.warn('no gsOne is provided');
    return '';
  }

  if (jIndex < 0) {
    console.warn('gsOne is not correctly formatted', gsOne);
    return '';
  }

  const serial = gsOne.slice(jIndex);

  return serial;
};
